export default __webpack_public_path__ + "static/media/screen3.4b7df828.png";